import { Language } from '@/types'

/**
 * Languages
 */
export const langDefault: Language = 'en'
export const langAvailable = ['en', 'fr'] as const
